import PropTypes from "prop-types";
//import GoogleTranslate from "./GoogleTranslate";
import React from "react";
import styled from "@emotion/styled";
import { AppBar, Avatar, Badge, Box, IconButton, Toolbar, Tooltip } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Notifications } from "./notification-list";
import { MenuList } from "./menu-list";
import SearchIcon from "@mui/icons-material/Search";
import { Bell as BellIcon } from "../icons/bell";
import { UserCircle as UserCircleIcon } from "../icons/user-circle";
import { Users as UsersIcon } from "../icons/users";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import i18n from "../language/i18n";

const HeaderChevron = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
        <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const HeaderGlobe = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 12h18M12 3c2.2 2.46 3.3 5.46 3.3 9S14.2 18.54 12 21c-2.2-2.46-3.3-5.46-3.3-9S9.8 5.46 12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const HappyMenuToggleIcon = () => (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">
        <path d="M21 17.9995V19.9995H3V17.9995H21ZM6.59619 3.90332L8.01041 5.31753L4.82843 8.49951L8.01041 11.6815L6.59619 13.0957L2 8.49951L6.59619 3.90332ZM21 10.9995V12.9995H12V10.9995H21ZM21 3.99951V5.99951H12V3.99951H21Z" />
    </svg>
);

const DashboardNavbarRoot = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== "isSidebarOpen"
})(({ theme, isSidebarOpen }) => ({
    backgroundColor: "#fff",
    boxShadow: "0 1px 8px rgba(15, 23, 42, 0.08)",
    minHeight: 56,
    transition: theme.transitions.create(["left", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up("lg")]: {
        left: isSidebarOpen ? 240 : 0,
        width: isSidebarOpen ? "calc(100% - 240px)" : "100%"
    }
}));

function DashboardNavbar(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [notifi, setNotifi] = useState(null);
    const openNotifi = Boolean(notifi);
    const [code, setCode] = useState(null);
    const [currentLang, setCurrentLang] = useState(() => localStorage.getItem("language") || "vi");

    const handleLanguageChange = (e) => {
        const lang = e.target.value;
        setCurrentLang(lang);
        localStorage.setItem("language", lang);
        i18n.changeLanguage(lang);
    };

    const [profile, setProfile] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("profile"));
        } catch (e) {
            return null;
        }
    });

    const handleclicknotifi = (event) => {
        setNotifi(event.currentTarget);
    };
    const handleclosenotifi = () => {
        setNotifi(null);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const sendData = () => {
        props.callback(true);
    };
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (res.data && res.data.data) {
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                    setProfile(res.data.data);
                    setCode(res.data.data.code);
                }
            })
            .catch((res) => {
                localStorage.removeItem("user");
                localStorage.removeItem("profile");
                localStorage.removeItem("data");
            });
    }, []);
    const handleCopyClick = (text) => {
        const textToCopy = text;
        const tempInput = document.createElement("input");
        tempInput.value = textToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        swal(t('success'), "Copy thành công", "success");
    };
    return (
        <>
            <DashboardNavbarRoot
                isSidebarOpen={props.isSidebarOpen}
                className="admin-theme happy-admin-header">
                <Toolbar
                    disableGutters
                    sx={{
                        minHeight: 56,
                        px: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                    <IconButton
                        onClick={() => (props.onSidebarOpen ? props.onSidebarOpen() : props.callback && props.callback())}
                        sx={{
                            display: {
                                xs: "inline-flex",
                                lg: "inline-flex"
                            }
                        }}>
                        <HappyMenuToggleIcon />
                    </IconButton>

                    {/* TOP RIGHT ACCOUNT & LANGUAGE BAR (Matching Image 2) */}
                    <Box className="happy-header-controls">
                        {/* Account Badge matching Image 2 */}
                        <Box
                            onClick={handleClick}
                            className="happy-header-account"
                            aria-controls={open ? "account-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                        >
                            <Avatar
                                className="happy-header-avatar"
                            >
                                {profile?.username ? profile.username[0].toUpperCase() : "S"}
                            </Avatar>
                            <span className="happy-header-username">
                                {profile?.username || "superadmin"}
                            </span>
                            <span className="happy-header-chevron"><HeaderChevron /></span>
                        </Box>

                        {/* Language Selector */}
                        <Box className="happy-header-language">
                            <span className="happy-header-globe"><HeaderGlobe /></span>
                            <select
                                value={currentLang}
                                onChange={handleLanguageChange}
                                className="happy-header-select"
                            >
                                <option value="vi">Tiếng Việt</option>
                                <option value="en">English</option>
                            </select>
                        </Box>
                    </Box>
                </Toolbar>
                <MenuList anchorEl={anchorEl} open={open} onClose={handleClose} onClick={handleClose} />
                <Notifications notification={notifi} openNotifi={openNotifi} onClose={handleclosenotifi} onClick={handleclosenotifi} />
            </DashboardNavbarRoot>
        </>
    );
}
export default DashboardNavbar;
DashboardNavbar.propTypes = {
    onSidebarOpen: PropTypes.func
};
